import { ReactElement } from 'react';
import storeConnector from '@store/storeConnector';
import useGetInternalWidgetConfig from '@src/hooks/api/queries/useGetInternalWidgetConfig';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import useSubscription from '@src/hooks/useSubscription';
import { SiteMeta } from '@src/types/SiteMeta';
import TopSwitchResistorSection from './components/TopSwitchResistorSection';
import BreakerStack from './components/BreakerStack';
import MultiSwitchConnector from '../components/MultiSwitchConnector/MultiSwitchConnector';
import {
  getUnitControllerDataPointsWithValues,
  UnitController,
} from './devicePointsConfig';
import C_Units from './components/C_Units';
import A_Units from './components/A_Units';
import D_Units from './components/D_Units';
import B_Units from './components/B_Units';
import Header from './components/Header';

type CanyonCountrySLDProps = {
  siteMeta: SiteMeta;
};

function CanyonCountry_Diagram(props: CanyonCountrySLDProps): ReactElement {
  const { siteMeta } = props;
  let unitControllersWithDataPointValues: UnitController[] = [];

  const { data: unitWidgetConfig } =
    useGetInternalWidgetConfig<WidgetTypeDeviceList>(
      'canyon_country_sld_unit',
      {
        sourceDeviceId: siteMeta.siteId,
      },
      { enabled: true },
    );

  const unitDataPointsWithValues = useSubscription(
    unitWidgetConfig?.dataPoints || [],
  );

  if (unitDataPointsWithValues.length > 0) {
    unitControllersWithDataPointValues = getUnitControllerDataPointsWithValues(
      unitDataPointsWithValues,
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xlinkHref='http://www.w3.org/1999/xlink'
      viewBox='200 40 1200 700'
      xmlSpace='preserve'
      colorInterpolationFilters='sRGB'
      className='st10'
      style={{ fill: 'none', stroke: 'currentColor', overflowX: 'auto' }}
    >
      <title>Canyon Country SLD</title>
      <Header />

      <TopSwitchResistorSection
        translateXCoordinate={75}
        translateYCoordinate={75}
      />

      <MultiSwitchConnector
        translateXCoordinate={313}
        translateYCoordinate={-295}
        verticalLength={20}
        horizontalLength={120}
        startingXCoordinate={410}
      />

      <MultiSwitchConnector
        translateXCoordinate={285}
        translateYCoordinate={-215}
        verticalLength={20}
        horizontalLength={50}
        startingXCoordinate={410}
      />

      <MultiSwitchConnector
        translateXCoordinate={390}
        translateYCoordinate={-215}
        verticalLength={20}
        horizontalLength={80}
        startingXCoordinate={410}
      />

      <BreakerStack
        translateXCoordinate={835}
        translateYCoordinate={-430}
        switchLabel='89F2-1'
        breakerLabel='52F2'
      />

      <BreakerStack
        translateXCoordinate={955}
        translateYCoordinate={-430}
        switchLabel='89F1-1'
        breakerLabel='52F1'
      />

      {/* F2 C Units */}
      {/*  1st number is horizontal , 2nd number is vertical */}
      <g transform='translate(-90 220)'>
        <C_Units
          unitControllersWithDataPointValues={
            unitControllersWithDataPointValues
          }
        />
      </g>

      {/* F1 A Units */}
      {/*  1st number is horizontal , 2nd number is vertical */}
      <g transform='translate(550 220)'>
        <A_Units
          unitControllersWithDataPointValues={
            unitControllersWithDataPointValues
          }
        />
      </g>

      {/* F2 D Units */}
      {/*  1st number is horizontal , 2nd number is vertical */}
      <g transform='translate(-70 350)'>
        <D_Units
          unitControllersWithDataPointValues={
            unitControllersWithDataPointValues
          }
        />
      </g>

      {/* F1 B Units */}
      {/*  1st number is horizontal , 2nd number is vertical */}
      <g transform='translate(490 350)'>
        <B_Units
          unitControllersWithDataPointValues={
            unitControllersWithDataPointValues
          }
        />
      </g>
    </svg>
  );
}

export default storeConnector(CanyonCountry_Diagram, {
  config: ['siteMeta'],
});
